export function parsePriceString(price: string | undefined | null): number | undefined {
  if (!price) return undefined;

  let normalized: string;
  if (/\d\.\d{3},/.test(price)) {
    // European: dot (e.g. "1.234,56 CHF")
    normalized = price.replaceAll(".", "").replaceAll(",", ".");
  } else if (/^\D*\d+,\d{1,2}\D*$/.test(price)) {
    // Simple decimal comma (e.g. "59,50 CHF")
    normalized = price.replaceAll(",", ".").replaceAll(/[^\d.]/g, "");
  } else {
    // English/Swiss: strip thousands separators (comma, apostrophe), keep decimal dot
    normalized = price.replaceAll(/[^\d.]/g, "");
  }

  const numeric = Number.parseFloat(normalized);
  return Number.isNaN(numeric) ? undefined : numeric;
}
